import { render, staticRenderFns } from "./TableBoxText.vue?vue&type=template&id=139a4d3a&scoped=true&"
import script from "./TableBoxText.vue?vue&type=script&lang=ts&"
export * from "./TableBoxText.vue?vue&type=script&lang=ts&"
import style0 from "./TableBoxText.vue?vue&type=style&index=0&id=139a4d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a4d3a",
  null
  
)

export default component.exports